import React from "react";
import "../style/infrac.css";
import Product_page from "./Product_page";

const Infrac: React.FC = () => {
  return (
    <>
      <div className="infra">
        <div className="infra_header">
          <h1>Our</h1>
          <h2>Manufacturing Unit</h2>
        </div>

        <div className="infra_content">
          <div className="infra_card">
            <div className="infra_img1"></div>
            <h3>
              1 acre of land with <br />
              6500 sq ft of building
            </h3>
          </div>
        </div>
      </div>
      <Product_page />
    </>
  );
};

export default Infrac;
